import { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'login',
    redirect: '/login',
    meta: { renderMenu: false },
  },
  {
    path: '/login',
    name: '登录',
    meta: { view: 'blank', cacheable: false, renderMenu: false },
    component: () => import('@/pages/login'),
  },
  {
    path: '/classifyRules',
    name: '分类的规则',
    meta: { view: 'blank', cacheable: false, renderMenu: false },
    component: () => import('@/pages/classifyRules'),
  },
  {
    path: '/403',
    name: '403',
    props: true,
    meta: { renderMenu: false },
    component: () => import('@/pages/Exp403.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    props: true,
    meta: { icon: 'CreditCardOutlined', renderMenu: false, cacheable: false, _is404Page: true },
    component: () => import('@/pages/Exp404.vue'),
  },
];

export default routes;
